/**
 * api接口统一管理
 */
import {
    http
} from "./http";

// 登录接口
export const accountLogin = data => http("/bs/account/accountLogin", 'post', data);
// 修改密码
export const updateAccount = data => http("/bs/account/updateAccount", 'post', data);
// 发送验证码
export const sendSms = data => http("/bs/account/sendSms", 'post', data);
// 查询部位
export const findByPositionIdList = data => http("/bs/doctor/ws/findByPositionNameList", 'post', data);
// 查询仪器列表
export const findByInstrumentIdList = data => http("/bs/project/ws/findByInstrumentNameList", 'post', data);
// 查询操作人列表
export const findByDoctorIdList = data => http("/bs/doctor/ws/findByDoctorNameList", 'post', data);
// 查询项目列表
export const findByProjectIdList = data => http("/bs/project/ws/findByProjectNameList", 'post', data);
// 根据项目id查找可用仪器部位以及操作人
export const findProjectBydId = data => http("/bs/project/ws/findProjectBydId", 'post', data);
// 新增预约
export const insertOrUpdateAppointment = data => http("/bs/appointment/ws/insertOrUpdateAppointment", 'post', data);
//查询预约列表
export const findAppointmentList = data => http("/bs/appointment/ws/findAppointmentList", 'post', data);
// 查询预约统计
export const findAppointmentCountByStatus = data => http("/bs/appointment/ws/findAppointmentCountByStatus", 'post', data);
// 仪器时间校验
export const findInstrumentFlag = data => http("/bs/appointment/ws/findInstrumentFlag", 'post', data);
// 修改预约状态
export const updateAppointmentStatusById = data => http("/bs/appointment/ws/updateAppointmentStatusById", 'post', data);
// 查询仪器使用时间
export const findInstrumentDateById = data => http("/bs/appointment/ws/findInstrumentDateById", 'post', data);
// 查询操作人
export const findDoctorByInstrumentDate = data => http("/bs/appointment/ws/findDoctorByInstrumentDate", 'post', data);
// 重置密码
export const resetPassword = data => http("/bs/account/resetPassword", 'post', data);
// 根据仪器id查找部位
export const findInstrumentById = data => http("/bs/instrument/ws/findInstrumentById", 'post', data);
// 退出登录
export const accountExit = data => http("bs/account/accountExit", 'post', data);
// 修改预约
export const updateAppointment = data => http("/bs/appointment/ws/updateAppointment", 'post', data);
// 根据预约ID查找详细信息
export const findAppiontmentById = data => http("/bs/appointment/ws/findAppiontmentById", 'post', data);
// 扫码提交参数
export const importScanInfo = data => http("/bs/scan/importScanInfo", 'post', data);
// 提交识别出的扫码信息
export const importScanImage = data => http("/bs/scan/importScanImage", 'post', data);
// 统计草稿箱
export const findDraftsCount = data => http("/bs/appointment/ws/findDraftsCount", 'post', data);
// 草稿箱列表
export const findAppointmentDraftsList = data => http("/bs/appointment/ws/findAppointmentDraftsList", 'post', data);
// 保存修改草稿箱数据
export const saveAppointmentDrafts = data => http("/bs/appointment/ws/saveAppointmentDrafts", 'post', data);
// 草稿箱回显
export const findAppointmentDrafts = data => http("/bs/appointment/ws/findAppointmentDrafts", 'post', data);
// 删除草稿箱
export const deleteAppointmentDrafts = data => http("/bs/appointment/ws/deleteAppointmentDrafts", 'post', data);
// 问卷新增
export const createQuesttionniare = data => http("/bs/questionnaire/ws/createQuesttionniare", 'post', data);
// 预约识别
export const findDistinguishData = data => http("/bs/appointment/ws/findDistinguishData", 'post', data);
// 预约预警信息查询
export const findAppointmentEchars = data => http("/bs/appointment/ws/findAppointmentEchars", 'post', data);
// 查询客户信息
export const getClientInformation = data => http("/bs/register/getClientInformation", 'post', data);


// WEBPACK FOOTER //
// ./src/axios/api.js